import styled from 'styled-components';
import { ReactElement, useEffect, useRef } from 'react';
import Navbar from '../navbar/navbar-lateral';
import { useLocation } from 'react-router-dom';
import { useWindowResize } from '../../../_hooks/use-window-resize';
import NavbarMobile from '../navbar/navbar-mobile';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  height: 100svh;
  max-height: 100svh;
`;

const MainContainer = styled.div`
  flex-grow: 4;
  //background: ${(props) => `url(${require(`../../../assets/img/bg.png`)})lightgray 50% / cover no-repeat`};
  background: url('/images/bg.png') lightgray 50% / cover no-repeat;
  overflow-y: auto;
  transition: opacity 0.5s;
  opacity: 1;
`;

const BaseLayout = ({ children }: { children: ReactElement }) => {
  const ref = useRef<HTMLDivElement>();
  const location = useLocation();
  const { isMobile } = useWindowResize();

  useEffect(() => {
    if (location.hash.length === 0) {
      ref.current?.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <PageWrapper>
      {isMobile ? <NavbarMobile /> : <Navbar />}
      {/* @ts-ignore */}
      <MainContainer ref={ref}>
        {children}
      </MainContainer>
    </PageWrapper>
  )
};

export default BaseLayout;